// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5140) return "static/chunks/5140.e26d2410e9d6c5fb.js";
	if (chunkId === 3563) return "static/chunks/3563.65ac3af4b2aebeaf.js";
	if (chunkId === 4586) return "static/chunks/4586.ba3ce70a41ddc0d5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"4171":"2b54597838f69f81","5495":"a68861a00bb4aa71","8124":"fb5a3c620a6d55ca","8185":"27daa2d420d69c36"}[chunkId] + ".js";
};